export enum WineColorEnum {
  ROUGE = "ROUGE",
  BLANC = "BLANC",
  ROSE = "ROSE",
  ROSEEFFERVESCENT = "ROSEEFFERVESCENT",
  BLANCEFFERVESCENT = "BLANCEFFERVESCENT",
  CHAMPAGNE = "CHAMPAGNE",
  AMBER = "AMBER",
}
